import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ChangeAdminPassword from "../../layout/admin/ChangeAdminPassword";
import Chatbox from "../../layout/common/Chatbox";
import Footer from "../../layout/common/Footer";
import Header from "../../layout/common/Header";
import NavHeader from "../../layout/common/NavHeader";
import SidebarTest from "../../layout/common/SidebarTest";

const ChangePassword = () => {
  const [showChtBox, setShowChtBox] = useState(false);
  const chtBoxHandler = (e) => {
    setShowChtBox(!e);
  };

  const chatboxClose = (e) => {
    setShowChtBox(!e);
  };
  return (
    <React.Fragment>
      <Helmet>
        <title>Change Password</title>
      </Helmet>
      <NavHeader />
      <Header onClick={chtBoxHandler} showChtBox={showChtBox} />
      <Chatbox showChtBox={showChtBox} chatboxClose={chatboxClose} />
      <SidebarTest />
      <ChangeAdminPassword />
      <Footer />
    </React.Fragment>
  );
};

export default ChangePassword;
